import { useQuestionizerStore } from "../types/state.ts";
import Toggle from "./toggle.tsx";

export default function InputGebaeudeTyp3 (props: {
  id: number, 
  label_einfamilienhaus?: string, 
  icon_einfamilienhaus: string, 
  icon_einfamilienhaus_active?: string, 
  label_mehrfamilienhaus?: string, 
  icon_mehrfamilienhaus: string, 
  icon_mehrfamilienhaus_active?: string,
  label_nichtwohngebaeude?: string,
  icon_nichtwohngebaeude: string,
  icon_nichtwohngebaeude_active?: string,
  onBlur?: ()=>void
}){
  const updateValidation = useQuestionizerStore((state) => state.updateValidation);
  const gebaeude = useQuestionizerStore((state) => state.gebaeude);
  const setGebaeude = useQuestionizerStore((state) => state.setGebaeude);
  const setGewerbegebaeude = useQuestionizerStore((state) => state.setGewerbegebaeude);
  const setGemeinnuetzig = useQuestionizerStore((state) => state.setGemeinnuetzig);
  //const wohngebaeude = useQuestionizerStore((state) => state.wohngebaeude);
  const setWohngebaeude = useQuestionizerStore((state) => state.setWohngebaeude);
  //const error_default = useQuestionizerStore((state) => state.translation.errors['input-gebaeudetyp--default']);
  const label_einfamilienhaus = props.label_einfamilienhaus || useQuestionizerStore((state) => state.translation.labels['input-gebaeudetyp--einfamilienhaus']);
  const label_mehrfamilienhaus = props.label_mehrfamilienhaus || useQuestionizerStore((state) => state.translation.labels['input-gebaeudetyp--mehrfamilienhaus']);
  const label_nichtwohngebaeude = props.label_nichtwohngebaeude || useQuestionizerStore((state) => state.translation.labels['input-gebaeudetyp--nichtwohngebaeude']);

  return <div className="section__inputs justify-center section__inputs--grid mb-6">
			<div className="tw-sm-hidden md:block sm:col-span-2 hidden lg:block"></div>
        <Toggle id={props.id+"-mfh"} label={label_mehrfamilienhaus} icon={props.icon_mehrfamilienhaus} icon_active={props.icon_mehrfamilienhaus_active} value={gebaeude == "Mehrfamilienhaus"} onBlur={props.onBlur} onChange={(_)=>{
          setGebaeude("Mehrfamilienhaus");   
          setWohngebaeude(true);
		  setGewerbegebaeude(false);
		  setGemeinnuetzig(false);
          updateValidation();    
        }}/>
         <Toggle id={props.id+"-nwg"} label={label_nichtwohngebaeude} icon={props.icon_nichtwohngebaeude} icon_active={props.icon_nichtwohngebaeude_active} value={gebaeude == "Nichtwohngebäude"} onBlur={props.onBlur} onChange={(_)=>{
          setGebaeude("Nichtwohngebäude");
          setWohngebaeude(false);
		  setGewerbegebaeude(true);
		  setGemeinnuetzig(true);
          updateValidation();
        }}/>
    </div>
}